import React from 'react';
import './Policy.css';

const AboutCamplocation: React.FC = () => {
  return (
    <div className="page-container">
      <h2>Welcome to Camplocation</h2>
      <p>
        We will help you to travel much easier. Please download our mobile Apps from Apple app store and Google play.
      </p>

      <p>
        If you need to find where to stop to relax, where to sleep, where to park your car, motorhome or camper van in the wild or city, 
        find drinking water or shower this is the App for you.
      </p>

      <p>
        This app is made for the camping community and people who love to travel, camp, stay in campsites or wild places, 
        travel by car, 4x4, motorhomes or camper vans. Let’s help each other by together improving the app where people can 
        upload the spots they have stayed and loved, upload the pictures of the spots, write the comments if they liked the spot and so on.
      </p>

      <p>
        There is nothing more frustrating while travelling, you are tired and you cannot find a place where to stay to sleep 
        or park your camper van. This App is mostly about that – to help you out.
      </p>

      <h3>The functions of the App are but not limited to:</h3>
      <ul>
        <li>Your location on the map where You can find the spots you need around You.</li>
        <li>Search for the spots You need in any location You want.</li>
        <li>Choose from Filters menu what type of spots You are interested in.</li>
        <li>
          See the desired spot description, photos of the spot, coordinates, other members’ comments about the spot and so on. 
          Upload Your photos of the spot or comment Yourself about the spot if You liked it or not.
        </li>
        <li>
          Use the app even in Offline mode if You do not have an internet connection, view the spots and find the info You need 
          even if You are in a wild location.
        </li>
        <li>Plan Your route from A to B by filtering only the spots You need so You can save them and use them later.</li>
        <li>See the Street view of the available location.</li>
        <li>
          When You find Yourself that perfect location please share it on the App by uploading the exact location, 
          uploading pictures, writing a description and other info about the spot so other fellow travellers 
          can enjoy the spot as much as You did.
        </li>
      </ul>

      <p>
        What problems does this App help to solve? I am a keen traveller myself. Been travelling for years with a small camper 
        in many different countries. While you are in unknown surroundings how to find where to stay to rest, 
        where to sleep at night, where to park your vehicle, how to find a quiet spot to run away from everyone, 
        where to find drinking water or shower? I spent many hours trying to find these spots on a map, zooming in and out, 
        stressed out at night where to sleep, driving many kilometres looking for a spot. Very often a supposed to be 
        an enjoyable trip became very frustrating and stressful. Then I started to think how I can help other travellers 
        to enjoy the trip more and also involve other travellers to help each other. Then Camplocation became a reality. 
        I hope You will love it and let’s help each other to have the most enjoyable trip.
      </p>

      <p>
        Enjoy the App and have a safe and enjoyable trip!
      </p>
    </div>
  );
};

export default AboutCamplocation;
